export default {
  relics: 'Relikte',
  museum: 'Museum',

  torch: 'Fackel',
  purpleHeart: 'Lila Herz',
  rottenLeaf: 'Verrottetes Blatt',
  stonepiercer: 'Steinspalter',
  consolationPrize: 'Trostpreis',
  prettyLamp: 'Schöne Lampe',
  chessboard: 'Schachbrett',
  iridiscentFlower: 'Schillernde Blume',
  excavator: 'Bagger',
  redCard: 'Rote Karte',
  briefcase: 'Aktentasche',
  strangePlant: 'Seltsame Pflanze',
  beneficialVirus: 'Gutartiges Virus',
  friendlyBat: 'Freundliche Fledermaus',
  hammer: 'Hammer',
  aluminiumBrick: 'Aluminiumziegel',
  copperBrick: 'Kupferziegel',
  aluminiumHeap: 'Aluminiumhaufen',
  bomb: 'Bombe',
  copperHeap: 'Kupferhaufen',
  radar: 'Radar',
  press: 'Presse',
  cupboard: 'Schrank',
  catalyst: 'Katalyst',
  jumprope: 'Springseil',
  bronzePickaxe: 'Bronzespitzhacke',
  oreShelf: 'Erzregal',
  coalBrick: 'Kohleziegel',
  washingMachine: 'Waschmaschine',
  magnet: 'Magnet',
  copperPickaxe: 'Kupferspitzhacke',
  tinBucket: 'Zinneimer',
  honeyPot: 'Honigtopf',
  openedGift: 'Geöffnetes Geschenk',
  mudBrick: 'Matschziegel',
  sapling: 'Setzling',
  keychain: 'Schlüsselanhänger',
  treasureChest: 'Schatztruhe',
  screwdriver: 'Schraubenzieher',
  rose: 'Rose',
  goldenKey: 'Goldener Schlüssel',
  supervisor: 'Manager',
  globe: 'Globus',
  forgottenShield: 'Vergessener Schild',
  burningSkull: 'Brennender Schädel',
  dumbbell: 'Hantel',
  energyDrink: 'Energydrink',
  luckyDice: 'Glückswürfel',
  newBackpack: 'Neuer Rucksack',
  crackedSafe: 'Geknackter Safe',
  ultimateGuide: 'Ultimative Anleitung',
  bandage: 'Pflaster',
  goldenCarrot: 'Goldene Karotte',
  goldenApple: 'Goldener Apfel',
  popcorn: 'Popcorn',
  roseQuartz: 'Rosenquartz',
  goldenSeed: 'Goldene Saat',
  trellis: 'Spalier',
  brickWall: 'Ziegelwand',
  printer: 'Drucker',
  lightbulb: 'Glühbirne',
  oldTV: 'Alter Fernseher',
  worryingMail: 'Besorgniserregende Post',
  redBalloon: 'Roter Luftballon',
  sackOfGold: 'Goldbeutel',
  shredder: 'Schredder',
  redprint: 'Rotpause',
  orangeBalloon: 'Oranger Luftballon',
  creditCard: 'Kreditkarte',
  simpleCalculator: 'Einfacher Taschenrechner',
  orangeprint: 'Orangepause',
  yellowBalloon: 'Gelber Luftballon',
  fishbowl: 'Fischglas',
  pencil: 'Bleistift',
  smallBrush: 'Kleiner Pinsel',
  strangePills: 'Seltsame Pillen',
  strangeScroll: 'Seltsame Schriftrolle',
  printingPress: 'Druckpresse',
  yellowprint: 'Gelbpause',
  greenBalloon: 'Grüner Luftballon',
  woodenHanger: 'Kleiderbügel',
  bedsheet: 'Bettlaken',
  imageAlbum: 'Bilderalbum',
  greenprint: 'Grünpause',
  blueBalloon: 'Blauer Luftballon',
  blueprint: 'Blaupause',
  purpleBalloon: 'Lila Luftballon',
  tinfoilHat: 'Aluhut',
  cupOfWater: 'Wasserbecher',
  combatStrategy: 'Kampfstrategie',
  hundredDollarBill: '100-Dollar-Note',
  hotAirBalloon: 'Heißluftballon',
  largeClover: 'Großes Kleeblatt',
  eightBall: 'Schwarze 8',
  youngPig: 'Junges Ferkel',
  silverHorseshoe: 'Silbernes Hufeisen',
  bronzeTools: 'Bronzewerkzeug',
  minersHat: 'Bergmannshelm',
  dictionary: 'Lexikon',
  expertTools: 'Expertenwerkzeug',
  bloodBag: 'Blutbeutel',
  geode: 'Geode',
  birthdayCake: 'Geburtstagskuchen',
  colorfulFlower: 'Farbenfrohe Blume',
  heatingBulb: 'Heizlampe',
  trashCan: 'Mülleimer',
  suitcase: 'Koffer',
  tropicalTent: 'Tropisches Zelt',
  fruitBasket: 'Obstkorb',
  massiveGrain: 'Riesiges Getreide',
  enchantedBottle: 'Verzauberte Flasche',
  moneyGift: 'Geldgeschenk',
  frozenCarrot: 'Gefrorene Karotte',
  consecutiveSignIn1: 'Aufeinanderfolgendes Anmelde-Geschenk 1',
  consecutiveSignIn2: 'Aufeinanderfolgendes Anmelde-Geschenk 2',
  consecutiveSignIn3: 'Aufeinanderfolgendes Anmelde-Geschenk 3',
  consecutiveSignIn4: 'Aufeinanderfolgendes Anmelde-Geschenk 4',
  consecutiveSignIn5: 'Aufeinanderfolgendes Anmelde-Geschenk 5',
  consecutiveSignIn6: 'Aufeinanderfolgendes Anmelde-Geschenk 6',
  consecutiveSignIn7: 'Aufeinanderfolgendes Anmelde-Geschenk 7',
  consecutiveSignIn8: 'Aufeinanderfolgendes Anmelde-Geschenk 8',
  consecutiveSignIn9: 'Aufeinanderfolgendes Anmelde-Geschenk 9',
  consecutiveSignIn10: 'Aufeinanderfolgendes Anmelde-Geschenk 10',
  consecutiveSignIn11: 'Aufeinanderfolgendes Anmelde-Geschenk 11',
};
